<template>
  <div>
    <el-switch
      v-model="status"
      :active-value="active"
      :active-text="showText ? 'Enable' : ''"
      :inactive-value="inActive"
      :inactive-text="showText ? 'Disable' : ''"
      :disabled="disabled"
      @change="showDialog = true"
    />
    <el-dialog
      :title="`${setAppStatus === active ? 'Disable' : 'Enable'} App`"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :show-close="false"
      width="28%"
    >
      <div>
        <p class="text-center">
          Are you sure you want to
          {{ setAppStatus === active ? "disable" : "enable" }} this app, <br />
          <span class="text-bold text-black">{{ appName }}</span> ?
        </p>
      </div>
      <span slot="footer">
        <el-button plain size="medium" @click="cancel">Cancel</el-button>
        <el-button
          type="primary"
          size="medium"
          :loading="updating"
          @click="change"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";

export default {
  name: "ApplicationStatusChange",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    appName: {
      type: String,
      default: ""
    },
    appId: {
      type: [String, Number],
      default: null
    },
    appStatus: {
      type: Number,
      default: null
    },
    showText: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showDialog: false,
      updating: false,
      status: apiConstants.GLOBAL_STATUS.INACTIVE,
      active: apiConstants.GLOBAL_STATUS.ACTIVE,
      inActive: apiConstants.GLOBAL_STATUS.INACTIVE
    };
  },

  computed: {
    setAppStatus: {
      get() {
        return this.appStatus;
      },
      set(value) {
        this.$emit("update:appStatus", value);
      }
    }
  },

  watch: {
    appStatus() {
      this.status = this.appStatus;
    }
  },

  created() {
    this.status = this.appStatus;
  },

  methods: {
    cancel() {
      this.status = this.setAppStatus;
      this.updating = false;
      this.showDialog = false;
    },
    change() {
      this.updating = true;
      const label = this.status === this.active ? "enabled" : "disabled";
      let apiUrl = `apps/${this.appId}/status`;
      const body = {
        status_id: this.status
      };

      this.$http
        .post(
          apiUrl,
          {
            body: body,
            method: "PUT"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.cancel();
          } else {
            this.updating = false;
            this.$emit("success");
            this.notification(
              "Completed",
              `Configuration is ${label}`,
              "success"
            );
            this.showDialog = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.cancel();
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
